// extracted by mini-css-extract-plugin
export default {"cardHeader":"card_cardHeader__AvRCY","cardBody":"card_cardBody__Ri6VV","cardBodyContain":"card_cardBodyContain__0mPa5","ellipsisText":"card_ellipsisText__o7K66"};